import styled from 'styled-components'

export const StyledNonSelectableText = styled.span`
  touch-callout: none;
  user-select: none;
`
